export class StockInTransactionsRequest{
    unitId : number;
    reportedFromData : any;
    reportedToData : any;
    transactionFromDate : any;
    transactionToDate : any;
    product:number;
}